import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { HonorLogo } from "./Logo";
import { ChevronRight, Menu, X } from "lucide-react";

const navLinks = [
  { label: "Academia", href: "#academia" },
  { label: "Rangos", href: "#rangos" },
  { label: "Ingresos", href: "#monetizacion" },
  { label: "Indicadores", href: "#indicadores" },
  { label: "Planes", href: "#planes" },
  { label: "Nosotros", href: "#nosotros" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/75 backdrop-blur-xl border-b border-[#3E4D36]/50"
          : "bg-transparent"
      }`}
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <a href="#" className="shrink-0" data-testid="nav-logo-link">
          <HonorLogo className="h-14 md:h-16" variant="white" />
        </a>

        <nav className="hidden lg:flex items-center gap-6">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-xs font-body text-white/75 hover:text-[#BEDD7D] transition-colors uppercase tracking-wider"
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="https://app.honor.trading/auth/login"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden md:inline-flex items-center gap-1 px-5 py-2.5 bg-[#BEDD7D] text-black font-display font-bold text-xs uppercase tracking-widest hover:bg-white hover:shadow-[0_0_25px_rgba(190,221,125,0.6)] transition-all"
            data-testid="nav-cta-ingresar"
          >
            Ingresar <ChevronRight className="w-3.5 h-3.5" />
          </a>
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-[#3E4D36]/40">
          <div className="flex flex-col py-4 px-6 gap-4">
            {navLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-white/80 uppercase tracking-wider text-sm py-2 border-b border-[#3E4D36]/30"
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="https://app.honor.trading/auth/login"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-flex items-center justify-center gap-1 px-5 py-3 bg-[#BEDD7D] text-black font-display font-bold uppercase tracking-widest text-sm"
              data-testid="mobile-nav-cta"
            >
              Ingresar a la plataforma
            </a>
          </div>
        </div>
      )}
    </motion.header>
  );
}
